import React from 'react';
import ReactDOM from 'react-dom';
import '../src/assets/styles/global.scss';
import '../src/assets/styles/tarteaucitron.scss';
import '../src/assets/styles/theme.scss';
import 'semantic-ui-css/semantic.min.css';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));

